import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import Rheostat from 'rheostat';
import { checkIfInteger } from '../../Utils/MathUtils';
import geometric from '../../Scss/Custom/RheostatSlider/geometric';
import './RangeSelectorComponent.css';
import { ChameleonRheostatHandle } from '../../Scss/Custom/RheostatSlider/ChameleonRheostatHandle';

class RangeSelectorComponent extends Component {
  static propTypes = {
    MIN_RANGE: PropTypes.number.isRequired,
    MAX_RANGE: PropTypes.number.isRequired,
    className: PropTypes.string.isRequired,
    sectionTitle: PropTypes.string.isRequired,
    range: PropTypes.array.isRequired,
    setValidity: PropTypes.func.isRequired,
    updateRange: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.MIN_RANGE = props.MIN_RANGE;
    this.MAX_RANGE = props.MAX_RANGE;
    this.className = props.className;
    this.sectionTitle = props.sectionTitle;
    this.updateRange = props.updateRange;
    this.setValidity = props.setValidity;
    this.lowerValue = createRef();
    this.higherValue = createRef();
    this.lowerValueMessage = createRef();
    this.higherValueMessage = createRef();
    this.updateInputRange = this.updateInputRange.bind(this);
    this.handleChangeSlider = this.handleChangeSlider.bind(this);
    this.handleChangeInput = this.handleChangeInput.bind(this);
    this.isValid = this.isValid.bind(this);
    this.validationMessage = this.validationMessage.bind(this);
    this.state = {
      inputRange: this.props.range
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.range !== prevProps.range) {
      this.setState(
        {
          inputRange: this.props.range
        },
        () => {
          this.lowerValueMessage.current.innerHTML = '';
          this.higherValueMessage.current.innerHTML = '';
        }
      );
    }
  }

  updateInputRange(inputRange) {
    this.setState({ inputRange });
  }

  static contextTypes = {
    t: PropTypes.func.isRequired
  };

  handleChangeSlider(sliderState) {
    this.updateRange(sliderState.values);
    this.updateInputRange(sliderState.values);
    this.setValidity(true);
    this.higherValueMessage.current.innerHTML = '';
    this.lowerValueMessage.current.innerHTML = '';
  }

  handleChangeInput(activeElement) {
    let lowerValue = parseInt(this.lowerValue.current.value, 10);
    let higherValue = parseInt(this.higherValue.current.value, 10);
    if (!this.isValid(lowerValue, higherValue).lowerValue && !this.isValid(lowerValue, higherValue).higherValue) {
      this.setValidity(true);
      this.updateRange([lowerValue, higherValue]);
    } else {
      this.setValidity(false);
    }
    this.updateInputRange([lowerValue, higherValue]);

    this.validationMessage(
      parseInt(this.lowerValue.current.value, 10),
      parseInt(this.higherValue.current.value, 10),
      activeElement
    );
  }

  isValid(lowerValue, higherValue) {
    return {
      lowerValue:
        isNaN(lowerValue) || lowerValue > higherValue || lowerValue > this.MAX_RANGE || lowerValue < this.MIN_RANGE,
      higherValue:
        isNaN(higherValue) || lowerValue > higherValue || higherValue > this.MAX_RANGE || higherValue < this.MIN_RANGE
    };
  }

  validationMessage(lowerValue, higherValue, activeElement) {
    let lowerCurrent = this.lowerValueMessage.current;
    let higherCurrent = this.higherValueMessage.current;
    const { t } = this.context;

    higherCurrent.innerHTML = '';
    lowerCurrent.innerHTML = '';
    if (lowerValue > higherValue) {
      higherCurrent.innerHTML = '';
      lowerCurrent.innerHTML = '';
      if (activeElement === 'higher') {
        higherCurrent.innerHTML = t('validationMessages.maxLessThanMin');
      } else {
        lowerCurrent.innerHTML = t('validationMessages.minMoreThanMax');
      }
    }
    if (higherValue > this.MAX_RANGE) {
      lowerCurrent.innerHTML = '';
      higherCurrent.innerHTML = t('validationMessages.maxExceedsRange') + this.MAX_RANGE;
    }
    if (lowerValue > this.MAX_RANGE) {
      higherCurrent.innerHTML = '';
      lowerCurrent.innerHTML = t('validationMessages.minExceedsRange') + this.MAX_RANGE;
    }
    if (lowerValue < this.MIN_RANGE) {
      higherCurrent.innerHTML = '';
      lowerCurrent.innerHTML = t('validationMessages.minBelowRange') + this.MIN_RANGE;
    }
    if (higherValue < this.MIN_RANGE) {
      lowerCurrent.innerHTML = '';
      higherCurrent.innerHTML = t('validationMessages.maxBelowRange') + this.MIN_RANGE;
    }
  }

  render() {
    const classNames = `rangeSelectorComponent ${this.className}`;
    const rangeValuesSlider = this.props.range;
    let errorsRange = this.isValid(this.state.inputRange[0], this.state.inputRange[1]);

    return (
      <div className={classNames}>
        <div className="sectionTitle">{this.sectionTitle}</div>
        <div className="sectionSlider">
          <Rheostat
            algorithm={geometric}
            min={this.MIN_RANGE}
            max={this.MAX_RANGE}
            handle={ChameleonRheostatHandle}
            values={rangeValuesSlider}
            onValuesUpdated={this.handleChangeSlider}
          />
        </div>
        <div className="inputSection">
          <div className="rangeInput">
            <input
              className={errorsRange.lowerValue ? 'errorRange' : 'lowerValue'}
              ref={this.lowerValue}
              type="number"
              value={this.state.inputRange[0]}
              onChange={() => this.handleChangeInput('lower')}
              onKeyPress={checkIfInteger}
            />
            <input
              className={errorsRange.higherValue ? 'errorRange' : 'higherValue'}
              ref={this.higherValue}
              type="number"
              value={this.state.inputRange[1]}
              onChange={() => this.handleChangeInput('higher')}
              onKeyPress={checkIfInteger}
            />
          </div>
          <div className="rangeMessage">
            <div className="lower" ref={this.lowerValueMessage} />
            <div className="higher" ref={this.higherValueMessage} />
          </div>
        </div>
      </div>
    );
  }
}

export default RangeSelectorComponent;



// WEBPACK FOOTER //
// ./src/Components/RangeSelector/RangeSelectorComponent.js